import { AbstractSearchArgument } from '../global'

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.contents = ''
  }
}

export {
  SearchArgument
}



// WEBPACK FOOTER //
// ./src/models/client/message-center.js